import { WireBindFromApi } from 'scenes/common/api/quote/types';

export const unmarshalReceiptNumber = (quote: WireBindFromApi): string =>
  quote.receiptNumber;
